import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const CardItem = styled(Box)(() => ({
  display: 'flex', 
  alignItems: 'center',
  justifyContent: 'space-between', 
  gap: '8px', 
  marginBottom: 16
}));

export const Input = styled('input')({ display: 'none' });